import { createSlice } from "@reduxjs/toolkit";
import  {getAllExam} from "../../builders/exam-assessment/exam-assessment.builder";

const initialState = {
    // facultyId: '',
    isAllExamInformationFilled: false,
    isAllExamInformationNextClicked: true,
    loading: false,
    allExam: [],
    module: [],
    topic: [],
    examData: [],
    examAssessPageData:{}
}

const allExamSlice = createSlice({
    name:'allexam',
    initialState,
    reducers:{
        examInformationFilled: (state,action) => {
            state.isAllExamInformationFilled = action.payload
        },
        examInformationNextClicked: (state, action) => {
            state.isAllExamInformationNextClicked = action.payload
        },
        setexamAssessPageData: (state, action) => {
            state.examAssessPageData = action.payload;
          },
        clearExtraReducers : (state) => {
            state.loading = false,
            state.allExam = [],
            state.module = [],
            state.topic = [],
            state.examData = [],
            state.examAssessPageData = {}
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllExam.pending, (state)=>{
            state.loading = true,
            state.allExam = []
        }),
        builder.addCase(getAllExam.fulfilled, (state, action)=>{
            state.loading = false
            state.allExam = action.payload
        }),
        builder.addCase(getAllExam.rejected, (state)=>{
            state.loading = false
        })
        // builder.addCase(getAllExam.fulfilled, (state, action)=>{
        //     state.loading = false
        //     state.facultyId = action.payload
        // }),
    }
})

export const { allExamInformationFilled,setexamAssessPageData , loading } = allExamSlice.actions

export default allExamSlice.reducer;